var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"input date-input",attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder},domProps:{"value":_vm.editValue},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }